export const LT_FEATURE_FLAG_UPDATE = 'LT_FEATURE_FLAG_UPDATE';
